<template>
  <div class="userCenter">
		<h3 >个人中心</h3>
		<el-form ref="userInfo" style="padding:10px" laber-width="120px">
			<el-form-item label="用户名:"><span>{{userInfo.userName}}</span></el-form-item>
			<!-- <el-form-item label="用户类型:"><span>{{user.userTypes}}</span></el-form-item> -->
			<el-form-item label="手机:">
				<span>{{userInfo.phone}}</span>
				<el-button v-if = userInfo.isFac&&false  type="success" size="mini" style="margin-left: 10px;" @click="setMyPhoneDialog=true">修改手机</el-button>
			</el-form-item>
			<el-form-item label="身份证号:"><span>{{userInfo.uniqueID}}</span></el-form-item>
			<!-- <el-form-item label="地址:"><span>{{userInfo.address}}</span></el-form-item> -->
			<el-form-item label="辖区:" v-if="isWorker==true"><span>{{userInfo.jurisdictions}}</span></el-form-item>
			<el-form-item label="是否采伐者:" v-if="isWorker==false">
				<span>{{userInfo.isFell?'是':'否'}}</span>
				<el-popover
					v-if="userInfo.isFell"
					placement="right"
				  trigger="click">
				  <el-table :data="tableData" align="center" :header-cell-style="{background:'#f4f7fe'}">
				    <el-table-column prop="Name" label="姓名/公司名"></el-table-column>
				    <el-table-column prop="IDCard" label="身份证/机构代码"></el-table-column>
				    <el-table-column prop="Address" label="地址"></el-table-column>
						<el-table-column  prop="State" label="状态">
							 <template slot-scope="scope">
						 		<el-tag type="warning"  v-if="scope.row.State === 0">审核中</el-tag>
						 		<el-tag type="success" v-if="scope.row.State === 1">审核通过</el-tag>
								<el-tag type="danger" v-if="scope.row.State === 2">审核不通过</el-tag>
						 	 </template>
						</el-table-column>
				  </el-table>
					<div class="page">
						<el-pagination
						  @size-change="handleSizeChange"
						  @current-change="handleCurrentChange"
						  :current-page.sync="currentPage"
						  :page-sizes="[10, 20]"
						  layout="sizes, prev, pager, next"
						  :total="total">
						</el-pagination>
					</div>
				  <el-button type="success" size="small" style="margin-left: 10px;" slot="reference" @click="lookInfo(1,'cls')">采伐者信息</el-button>
				</el-popover>
			</el-form-item>
			<el-form-item label="是否是加工厂/集材场:" v-if="isWorker==false">
				<span>{{userInfo.isFac?'是':'否'}}</span>
				<el-popover
					v-if="userInfo.isFac"
					placement="right"
				  trigger="click">
				  <el-table :data="tableData" height="300px" align="center" style="width: 100%">
				    <el-table-column prop="FacName" label="企业名称"></el-table-column>
				    <el-table-column prop="Corporation" label="法人"></el-table-column>
						<el-table-column prop="IDCard" label="身份证/机构代码"></el-table-column>
				    <el-table-column prop="Address" label="经营地址"></el-table-column>
						<el-table-column prop="State" label="状态">
							 <template slot-scope="scope">
						 		<el-tag type="warning"  v-if="scope.row.State === 0">审核中</el-tag>
						 		<el-tag type="success" v-if="scope.row.State === 1">审核通过</el-tag>
								<el-tag type="danger" v-if="scope.row.State === 2">审核不通过</el-tag>
						 	 </template>
						</el-table-column>
				  </el-table>
					<div class="page">
						<el-pagination
						  @size-change="handleSizeChange"
						  @current-change="handleCurrentChange"
						  :current-page.sync="currentPage"
						  :page-sizes="[10, 20]"	
						  layout="sizes, prev, pager, next"
						  :total="total">
						</el-pagination>
					</div>
				  <el-button type="success" size="small" style="margin-left: 10px;" slot="reference" @click="lookInfo(2,'cls')">加工厂信息</el-button>
				</el-popover>
			</el-form-item>
			<el-form-item label="地图派绑定:"  v-if="isWorker==true">
				<div class="flex align-center">
					<span class="margin-right">{{userInfo.mapPhone}}</span>
					<div v-if="userInfo.mapLoginState==1">
						<el-tag type="success">绑定成功</el-tag>
					</div>
					<div v-if="userInfo.mapLoginState==2">
						<el-tag type="danger">地图派服务器异常</el-tag>
					</div>
					<div v-if="userInfo.mapLoginState==3">
						<el-tag type="warning">账号密码异常</el-tag>
						<el-button type="success" style="padding: 8px!important;font-size: 12px;margin-left: 15px;" @click="dialogVisible=true">重新绑定</el-button>
					</div>
				</div>
			</el-form-item>
			
			<el-dropdown class="margin-right-xs" @command="handleCommand" v-if =false>
				<el-button type="success" >操作手册</el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-if="isWorker==false" command="6">普通人员操作手册</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==false" command="7">集材场</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==false" command="8">采伐申请人操作手册</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==true" command="9">工作人员操作手册</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==true" command="10">巡护人员操作手册</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==true" command="11">林长操作手册</el-dropdown-item>
					<el-dropdown-item v-if="isWorker==false&&userInfo.isSJGS" command="12">设计公司操作手册</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
			
			<el-button type="success" @click="changeDialogVisible=true">修改密码</el-button>
		</el-form>
		
		<el-dialog title="修改密码" :visible.sync="changeDialogVisible" :close-on-click-modal="false" width="30%" :append-to-body="true">
		  <div>
		    <el-form :model="changePasForm" :rules="rules" ref="changePasForm" label-width="10px" class="borderBtm" size="medium">
		      <el-form-item label='原密码：' label-width='85px' prop="oldPassword">
		        <el-input type="password" v-model="changePasForm.oldPassword" autocomplete="off" placeholder="原密码" show-password clearable></el-input>
		      </el-form-item>
		      <el-form-item label='新密码：' label-width='85px' prop="newPassword">
		        <el-input type="password" v-model="changePasForm.newPassword" autocomplete="off" placeholder="新密码" show-password clearable></el-input>
		      </el-form-item>
		      <el-form-item label='确认密码：' label-width='85px' prop="checkPassword">
		        <el-input type="password" v-model="changePasForm.checkPassword" autocomplete="off" placeholder="确认密码" show-password clearable></el-input>
		      </el-form-item>
		
		      <el-form-item class="setBtn">
		        <el-button type="success" @click="changePassSubmit('changePasForm')">确定修改</el-button>
		        <el-button @click="changeDialogVisible = false">取 消</el-button>
		      </el-form-item>
		    </el-form>
		  </div>
		</el-dialog>
		
		<!-- 重新绑定地图派 -->
		<el-dialog title="重新绑定" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%" :append-to-body="true">
		  <div>
		    <el-form label-width="120px">
		      <el-form-item label='地图派手机号：'>
		        <el-input v-model="mapPhone" placeholder="请输入地图派手机号"></el-input>
		      </el-form-item>
		      <el-form-item label='地图派密码：'>
		        <el-input type="password" v-model="password" autocomplete="off" placeholder="请输入地图派密码" show-password clearable></el-input>
		      </el-form-item>
		      <el-form-item class="setBtn">
		        <el-button type="success" @click="binding">提交</el-button>
		        <el-button @click="dialogVisible = false;password=''">取 消</el-button>
		      </el-form-item>
		    </el-form>
		  </div>
		</el-dialog>

		<!-- 普通人员修改手机号 -->
		<el-dialog title="修改手机" :visible.sync="setMyPhoneDialog" :close-on-click-modal="false" width="30%" :append-to-body="true">
		  <div>
		    <el-form label-width="120px">
		      <el-form-item label='新手机号：'>
		        <el-input v-model="newPhone" placeholder="请输入新手机号"></el-input>
		      </el-form-item>
		      <el-form-item class="setBtn">
		        <el-button type="success" @click="setNewPhone">确认</el-button>
		        <el-button @click="setMyPhoneDialog = false">取 消</el-button>
		      </el-form-item>
		    </el-form>
		  </div>
		</el-dialog>
  </div>
</template>

<script>
import { GetUserFellList ,GetUserFacList,changePasswordNew,SetMyPhone} from "@/api/user";
import { ChangePasswordByOriginal,UpdateMapUser} from "@/api/staff";
import  {myConfig} from "@/static/utils/lyconfig"

export default {
  name: "userCenter",
  data() {
		var validatePass1 = (rule, value, callback) => {
		  if (value === "") {
		    callback(new Error("请输入原密码"));
		  } else {
		    callback();
		  }
		};
		var validatePass2 = (rule, value, callback) => {
		  if (value === "") {
		    callback(new Error("请输入新密码"));
		  } else if (value.length < 6) {
		    callback(new Error("新密码长度应大于等于6位"));
		  } else {
		    callback();
		  }
		};
		var validatePass3 = (rule, value, callback) => {
		  if (value !== this.changePasForm.newPassword) {
		    callback(new Error("两次输入密码不一致!"));
		  } else {
		    callback();
		  }
		};
    return {
			url:"",
			token:"",
			changeDialogVisible:false,
			setMyPhoneDialog:false,
			newPhone:'',
			changePasForm:{
				oldPassword:'',
				newPassword:'',
				checkPassword:''
			},//修改密码表单
      		tableData: [], // 表格数据
			userInfo:{},//用户信息
      		total: 10, // 数据总数
      		currentPage: 1, // 当前页数
      		pageSize: 10, // 当前查询数据个数
      		isCheckDialogVisible: false, // 审批对话框是否显示
      		dialogVisible: false, // 地图派重新绑定
			currentType:1,//当前操作类型
			rules: {
			  code: [{ required: true, message: "未输入验证码", trigger: "blur" }],
			  oldPassword: [{ validator: validatePass1, trigger: "blur" }],
			  newPassword: [{ validator: validatePass2, trigger: "blur" }],
			  checkPassword: [{ validator: validatePass3, trigger: "blur" }]
			},
			isWorker:false,
			password:'',
			mapPhone:''
		};
	},
	computed:{
		user() {
			return this.$store.state.user;
		},
	},
  mounted() {
		this.token = JSON.parse(localStorage.getItem('user-token'))
		this.userInfo = JSON.parse(localStorage.getItem('user'))
		this.isWorker = JSON.parse(localStorage.getItem('isWorker'))
		this.url= myConfig.baseUrl
  },
  methods: {
		handleCommand(command)
		{
			let a = this.isWorker==true?1:2
			window.open(this.url+"File/DownFiles?type="+command+"&isWorker="+a+"&token="+this.token, '_blank')
		},
		//修改我的手机
		setNewPhone(){
			let params = {
				Phone:this.newPhone,
			}
			SetMyPhone(params).then(res => {
				if (res.data.state == 1) {
					this.$message({
						message: "修改成功",
						type: "success"
					});
					this.setMyPhoneDialog = false
					this.userInfo.phone = this.newPhone
					this.$store.commit('set_user',this.userInfo)
				} 
				else {
					this.$message.error(res.data.msg);
				}
			});
		},
		// 分页查询
		handleSizeChange(e){
			this.pageSize = e
			this.lookInfo(this.currentType)
		},
		handleCurrentChange(e){
			this.currentPage = e
			this.lookInfo(this.currentType)
		},
		// 地图派绑定
		binding(){
			let reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/;
			if (!this.mapPhone) {
				return this.$message.error('请输入地图派手机号')
			}
			if (!reg.test(parseInt(this.mapPhone))) {
				return this.$message.error('请输入正确电话号码')
			}
			if(this.password == ''){
				return this.$message.error('密码不能为空')
			}
			let params = {
				mapPhone:this.mapPhone,
				password:this.password
			}
			UpdateMapUser(params).then(res=>{
				if(res.data.state==1){
					this.userInfo.mapLoginState = 1
					this.userInfo.mapToken = res.data.data
					localStorage.setItem('user', JSON.stringify(this.userInfo))
					this.mapPhone = ''
					this.password = ''
					this.dialogVisible = false
					
				}else{
					this.$message.error(res.data.msg)
				}
			})
		},
		// 修改密码
		changePassSubmit (formName) {
		  this.$refs[formName].validate(valid => {
		    if (valid) {
		      var param = {
		        oldPassword:this.changePasForm.oldPassword,
		        newPassword: this.changePasForm.newPassword
		      };
					let isWorker = JSON.parse(localStorage.getItem('isWorker'));
					if(isWorker == true){
						ChangePasswordByOriginal(param).then(res => {
						  if (res.data.state == 1) {
						    this.$message({
						      message: "修改成功,请重新登陆",
						      type: "success"
						    });
						    this.changeDialogVisible = false;
								this.$router.push('/');
								localStorage.clear();
						  } else {
						    this.$message.error(res.data.msg);
						  }
						});
					}else{
						changePasswordNew(param).then(res => {
						  if (res.data.state == 1) {
						    this.$message({
						      message: "修改成功,请重新登陆",
						      type: "success"
						    });
						    this.changeDialogVisible = false;
								this.$router.push('/');
								localStorage.clear();
						  } else {
						    this.$message.error(res.data.msg);
						  }
						});
					}
		    } else {
		      return false;
		    }
		  });
		},
		// 查看表单信息
		lookInfo(type,cls){
			this.currentType = type
			if(cls){
				this.total = 10
				this.currentPage=1
				this.pageSize = 10
			}
			let params = {
				pageNumber:this.currentPage,
				pageSize:this.pageSize
			}
			if(this.currentType==1){
				GetUserFellList(params).then(res=>{
					if(res.data.state == 1){
					let	data = JSON.parse(res.data.data)
						this.tableData = data.Lis
						this.total = data.Count
					}else{
					this.$message.error(data.msg)
				}
				})
			}else{
				GetUserFacList(params).then(res=>{
					if(res.data.state == 1){
					let	data = JSON.parse(res.data.data)
						this.tableData = data.Lis
						this.total = data.Count
					}else{
					this.$message.error(data.msg)
				}
				})
			}
		},
  },
};
</script>
<style lang="less" scoped>
.userCenter {
  height: 100%;
	padding: 20px;
  .search {
    padding: 30px;
    .el-input {
      margin-right: 30px;
      width: 500px;
    }
  }
  .table {
    padding: 0px 30px 0px 30px;
  }
  .page {
    text-align: center;
  }
  /deep/ .el-dialog__header {
    padding: 10px;
    background-color: #5bacf0;
  }
  /deep/ .el-dialog__title {
    color: #fff;
  }
  /deep/ .el-dialog__body {
    padding: 15px;
  }
  /deep/ .el-dialog__footer {
    padding: 0px 10px 10px 10px;
  }
}
</style>
